var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarantia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.421 84.0528C168.065 76.1134 163.259 68.9849 157.136 62.8638C151.013 56.7404 143.884 51.9349 135.947 48.5789C127.729 45.0998 119 43.3398 110 43.3398C100.999 43.3398 92.2704 45.0998 84.0528 48.5789C76.1134 51.9349 68.9849 56.7404 62.8638 62.8638C56.7404 68.9871 51.9349 76.1155 48.5789 84.0528C45.0998 92.2704 43.3398 100.999 43.3398 110C43.3398 119 45.0998 127.729 48.5789 135.947C51.9349 143.886 56.7404 151.015 62.8638 157.136C68.9871 163.259 76.1155 168.065 84.0528 171.421C92.2704 174.9 100.999 176.66 110 176.66C119 176.66 127.729 174.9 135.947 171.421C143.886 168.065 151.015 163.259 157.136 157.136C163.257 151.013 168.065 143.884 171.421 135.947C174.9 127.729 176.66 119 176.66 110C176.66 100.999 174.9 92.2704 171.421 84.0528ZM101.532 150.831L83.8242 135.632L66.7698 120.996L81.924 103.339L97.5979 116.792L134.441 69.1683L153.223 82.8989L101.528 150.831H101.532Z",
    fill: "url(#paint0_linear_2272_9289)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 110.052L207.715 90.6141L211.651 67.9606L192.882 54.6851L187.813 32.2624L165.388 27.2002L152.143 8.40529L129.485 12.2812L110.052 0L90.6141 12.2855L67.9606 8.34922L54.6851 27.1182L32.2624 32.1869L27.2002 54.6118L8.40529 67.8571L12.2812 90.5149L0 109.948L12.2855 129.386L8.34922 152.039L27.1182 165.315L32.1869 187.738L54.6118 192.8L67.8571 211.595L90.5149 207.719L109.948 219.998L129.386 207.712L152.039 211.649L165.315 192.88L187.738 187.811L192.8 165.386L211.595 152.141L207.719 129.483L219.998 110.05L220 110.052ZM110 188.219C66.8002 188.219 31.7814 153.2 31.7814 110C31.7814 66.8002 66.8002 31.7814 110 31.7814C153.2 31.7814 188.219 66.8002 188.219 110C188.219 153.2 153.2 188.219 110 188.219Z",
    fill: "url(#paint1_linear_2272_9289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2272_9289",
    x1: 176.66,
    y1: 110,
    x2: 43.3398,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C1B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B02028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#781C27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2272_9289",
    x1: 220,
    y1: 109.999,
    x2: 0,
    y2: 109.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C1B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B02028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#781C27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarantia);
export default __webpack_public_path__ + "static/media/garantia.3e23a69940809c7be1982da0c239b87d.svg";
export { ForwardRef as ReactComponent };